export default __webpack_public_path__ + "static/media/pricing-icon.e7eca720.svg";